import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 right-0 h-full w-full max-w-md bg-white z-50 flex flex-col shadow-2xl"
}
const _hoisted_2 = { class: "flex items-center justify-between px-5 py-4 border-b border-secondary-200" }
const _hoisted_3 = { class: "text-lg font-bold text-primary-800" }
const _hoisted_4 = {
  key: 0,
  class: "ml-2 text-sm font-normal text-secondary-500"
}
const _hoisted_5 = {
  key: 0,
  class: "flex-1 flex flex-col items-center justify-center text-center px-6"
}
const _hoisted_6 = {
  key: 1,
  class: "flex-1 overflow-y-auto px-5 py-4 space-y-4"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "flex-1 min-w-0" }
const _hoisted_9 = { class: "text-xs text-accent-500 mb-0.5" }
const _hoisted_10 = { class: "text-sm font-semibold text-primary-800 leading-snug line-clamp-2" }
const _hoisted_11 = { class: "text-xs text-secondary-400 mt-0.5" }
const _hoisted_12 = { class: "flex items-center justify-between mt-2" }
const _hoisted_13 = { class: "flex items-center border border-secondary-200 rounded-lg overflow-hidden text-sm" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "px-2.5 py-1 border-x border-secondary-200 font-medium text-primary-800 min-w-[2rem] text-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "flex items-center gap-2" }
const _hoisted_18 = { class: "text-sm font-bold text-primary-800" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 2,
  class: "border-t border-secondary-200 px-5 py-4 space-y-3"
}
const _hoisted_21 = { class: "flex justify-between text-sm text-secondary-600" }
const _hoisted_22 = { class: "flex justify-between font-bold text-primary-800 border-t border-secondary-100 pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-black bg-opacity-40 z-40",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h2", _hoisted_3, [
                  _cache[5] || (_cache[5] = _createTextVNode(" Shopping Cart ", -1)),
                  (_ctx.itemCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_ctx.itemCount) + " items)", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", {
                  class: "p-1.5 text-secondary-400 hover:text-primary-800 transition-colors rounded-lg hover:bg-secondary-100",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("svg", {
                    class: "w-5 h-5",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))])
              ]),
              (_ctx.isEmpty)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[7] || (_cache[7] = _createElementVNode("svg", {
                      class: "w-16 h-16 text-secondary-200 mb-4",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1.5",
                        d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13l-1.5 6h13M7 13L5.4 5M10 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                      })
                    ], -1)),
                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-lg font-semibold text-primary-800 mb-1" }, "Your cart is empty", -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-sm text-secondary-500 mb-6" }, "Add some construction materials to get started.", -1)),
                    _createElementVNode("button", {
                      class: "bg-primary-800 hover:bg-accent-300 text-white text-sm font-semibold px-6 py-2.5 rounded-xl transition-colors",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goShop && _ctx.goShop(...args)))
                    }, " Browse Products ")
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItems, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.product.id,
                        class: "flex gap-3"
                      }, [
                        _createElementVNode("img", {
                          src: item.product.images[0]?.url,
                          alt: item.product.name,
                          class: "w-16 h-16 rounded-lg object-cover flex-shrink-0 border border-secondary-200"
                        }, null, 8, _hoisted_7),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", _hoisted_9, _toDisplayString(item.product.category.name), 1),
                          _createElementVNode("p", _hoisted_10, _toDisplayString(item.product.name), 1),
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.formatPrice(item.product.price)) + " / " + _toDisplayString(item.product.unit), 1),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("button", {
                                class: "px-2 py-1 hover:bg-secondary-100 text-primary-800 transition-colors",
                                onClick: ($event: any) => (_ctx.updateQty(item.product.id, item.quantity - 1))
                              }, "−", 8, _hoisted_14),
                              _createElementVNode("span", _hoisted_15, _toDisplayString(item.quantity), 1),
                              _createElementVNode("button", {
                                class: "px-2 py-1 hover:bg-secondary-100 text-primary-800 transition-colors",
                                onClick: ($event: any) => (_ctx.updateQty(item.product.id, item.quantity + 1))
                              }, "+", 8, _hoisted_16)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatPrice(item.product.price * item.quantity)), 1),
                              _createElementVNode("button", {
                                class: "text-secondary-300 hover:text-red-500 transition-colors",
                                onClick: ($event: any) => (_ctx.removeItem(item.product.id))
                              }, [...(_cache[10] || (_cache[10] = [
                                _createElementVNode("svg", {
                                  class: "w-4 h-4",
                                  fill: "none",
                                  stroke: "currentColor",
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                  })
                                ], -1)
                              ]))], 8, _hoisted_19)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])),
              (!_ctx.isEmpty)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", null, "Subtotal", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatPrice(_ctx.subtotal)), 1)
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex justify-between text-sm text-secondary-600" }, [
                      _createElementVNode("span", null, "Delivery"),
                      _createElementVNode("span", null, "RWF 5,000")
                    ], -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", null, "Total", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatPrice(_ctx.subtotal + 5000)), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "w-full bg-primary-800 hover:bg-primary-700 text-white font-semibold py-3 rounded-xl transition-colors text-sm",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goCheckout && _ctx.goCheckout(...args)))
                    }, " Proceed to Checkout "),
                    _createElementVNode("button", {
                      class: "w-full text-sm text-secondary-500 hover:text-primary-800 transition-colors py-1",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                    }, " Continue Shopping ")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}